import {ReactNode} from "react";
import styled from "@emotion/styled";
import {NavLink} from "react-router-dom";

export interface SidebarIconProps {
    icon: ReactNode;
    full: boolean;
    path: string;
    label?: string;
}

const SidebarIcon = ({icon, label, full, path}: SidebarIconProps) => {
    if (full) {
        return (<FullWrapper to={path}>
            <div className="icon">
                {icon}
            </div>
            {
                label && <Label>{label}</Label>
            }
        </FullWrapper>);
    }
    return (<MiniWrapper to={path}>
        <div className="icon">
            {icon}
        </div>
        {
            label && <Label>{label}</Label>
        }
    </MiniWrapper>);
}

const FullWrapper = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  font-style: normal;
  padding: 8px;
  cursor: pointer;
  text-decoration: none;
  color: black;
  
  .icon {
    padding: 7px 12px 4px 12px;
  }
  
  label {
    min-width: 150px;
    text-align: start;
  }
  
  :hover {
    .icon {
      border-radius: 12px;
      background: #D6D9E4;
    }
  }
`;

const MiniWrapper = styled(NavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
  font-style: normal;
  padding: 8px;
  cursor: pointer;
  text-decoration: none;
  color: black;
  
  .icon {
    padding: 7px 12px 4px 12px;
  }
  
  :hover {
    .icon {
      border-radius: 12px;
      background: #D6D9E4;
    }
  }
`;

const Label = styled.label`
    font-weight: normal;
`;

export default SidebarIcon;